require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./area-under-the-curve.json") })
        }
      }, "path---area-under-the-curve");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---area-under-the-curve!./.cache/json/area-under-the-curve.json
// module id = 832
// module chunks = 231608221292675